import { render, staticRenderFns } from "./alarm_event_unusual.vue?vue&type=template&id=bb3165f8&"
import script from "./alarm_event_unusual.vue?vue&type=script&lang=js&"
export * from "./alarm_event_unusual.vue?vue&type=script&lang=js&"
import style0 from "./alarm_event_unusual.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports